import { getContext, setContext } from 'svelte';
import type { PdfContext } from '../types';

const PDF_CONTEXT_KEY = Symbol('pdf-context');

/**
 * PDF Context 설정
 */
export const setPdfContext = (context: PdfContext): void => {
    setContext(PDF_CONTEXT_KEY, context);
};

/**
 * PDF Context 가져오기
 */
export const getPdfContext = (): PdfContext => {
    const context = getContext<PdfContext>(PDF_CONTEXT_KEY);

    if (!context) {
        throw new Error('PDF Context not found. Make sure to use PdfViewer as a parent component.');
    }

    return context;
};

/**
 * PDF Context 존재 여부 확인
 */
export const hasPdfContext = (): boolean => {
    return !!getContext<PdfContext>(PDF_CONTEXT_KEY);
};
